import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GoogleAnalyticsEventService } from '@services/google-analytics-events.service.service';

@Component({
    selector: 'app-support-faq',
    templateUrl: './support-faq.component.html',
    styleUrls: ['../support-page.component.scss'],
    standalone: false
})
export class SupportFaqComponent implements OnChanges {

  @Input() isVisible: boolean = false;

  dummyVariable: string = 'dummy';

  constructor(
    private gaService: GoogleAnalyticsEventService,
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isVisible.currentValue) {
      this.sendGATracking();
    }
  }

  /**
   * Track Google Analytics
   *
   */
  sendGATracking() {

    this.gaService.sendEvent('Support', 'FAQ', 'View', 1);


  }

  /**
   * Track clicking external link
   *
   * @param url
   */
  trackOutboundLink(url: string) {
    this.gaService.sendEvent('Support', 'FAQ', 'Outbound Link - ' + url, 1);
  }

}
